import {
    Chart,
    BarController, BarElement,
    DoughnutController, ArcElement,
    CategoryScale, LinearScale,
    Tooltip, Legend,
} from 'chart.js';

Chart.register(BarController, BarElement, DoughnutController, ArcElement, CategoryScale, LinearScale, Tooltip, Legend);

const COLOR = 'rgba(30, 100, 200, 0.75)';
const COLOR_HOVER = 'rgba(30, 100, 200, 1)';

const DONUT_COLORS = [
    '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6',
    '#06b6d4', '#f97316', '#84cc16', '#ec4899', '#6366f1',
    '#14b8a6', '#a855f7', '#0ea5e9', '#d946ef',
];

function makeBar(id, labels, data, labelText) {
    const canvas = document.getElementById(id);
    if (!canvas) return;
    new Chart(canvas, {
        type: 'bar',
        data: {
            labels,
            datasets: [{
                label: labelText,
                data,
                backgroundColor: COLOR,
                hoverBackgroundColor: COLOR_HOVER,
                borderRadius: 2,
            }],
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: { display: false },
                tooltip: { mode: 'index' },
            },
            scales: {
                x: { grid: { display: false } },
                y: { beginAtZero: true, ticks: { precision: 0 } },
            },
        },
    });
}

function makeDonut(id, labels, data) {
    const canvas = document.getElementById(id);
    if (!canvas) return;
    new Chart(canvas, {
        type: 'doughnut',
        data: {
            labels,
            datasets: [{
                data,
                backgroundColor: DONUT_COLORS.slice(0, data.length),
                borderWidth: 2,
                borderColor: '#fff',
            }],
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            cutout: '65%',
            plugins: {
                legend: { display: false },
                tooltip: { mode: 'index' },
            },
        },
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const el = document.getElementById('dashboard-data');
    if (!el) return;

    const d = JSON.parse(el.textContent);

    makeDonut('chart-states', d.stateDist.labels, d.stateDist.data);

    const legend = document.getElementById('state-legend');
    if (legend && d.stateDist.labels.length) {
        legend.innerHTML = d.stateDist.labels.map((label, i) => {
            const color = DONUT_COLORS[i % DONUT_COLORS.length];
            return `<li><span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${color};margin-right:6px"></span>${label}: <strong>${d.stateDist.data[i]}</strong></li>`;
        }).join('');
    }

    const PERIOD_TITLES = { day: 'pro Tag', week: 'pro Woche', month: 'pro Monat' };
    const setPeriodTitle = (id, prefix, period) => {
        const el = document.getElementById(id);
        if (el && period) {
            el.textContent = `${prefix} ${PERIOD_TITLES[period.unit] || 'pro Tag'}`;
        }
    };

    setPeriodTitle('per-period-title', 'Teilnehmer', d.perPeriod);
    setPeriodTitle('img-per-period-title', 'Bilder', d.imgPerPeriod);

    makeBar('chart-per-day',  d.perPeriod.labels, d.perPeriod.data, 'Teilnehmer');
    makeBar('chart-per-hour', d.perHour.labels,   d.perHour.data,   'Teilnehmer');

    if (d.imgPerPeriod) {
        makeBar('chart-images-per-day', d.imgPerPeriod.labels, d.imgPerPeriod.data, 'Bilder');
    }
});
